import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { api } from '@/lib/api/endpoints'
import type { VoypUser } from '@/lib/api/types'
import { queryKeys } from './keys'

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profile,
    queryFn: api.getProfile,
    staleTime: 60_000,
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (update: Partial<VoypUser> & Record<string, unknown>) => api.updateProfile(update),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.profile })
    },
    onError: (error) => {
      toast.error('Could not save settings', { description: error.message })
    },
  })
}
